"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.5 4c3.564 0 6.651 2.561 7.346 6.023C21.758 10.232 24 12.609 24 15.5c0 3.033-2.468 5.5-5.5 5.5h-14A4.505 4.505 0 0 1 0 16.5a4.507 4.507 0 0 1 4.022-4.475A6.391 6.391 0 0 1 4 11.5C4 7.364 7.364 4 11.5 4Zm0 1A6.508 6.508 0 0 0 5 11.5c0 .282.024.58.076.937a.5.5 0 0 1-.12.402.566.566 0 0 1-.384.169l-.106-.009C2.57 13 1 14.57 1 16.5S2.57 20 4.5 20h14c2.481 0 4.5-2.019 4.5-4.5a4.506 4.506 0 0 0-4.288-4.495L18.5 11c-.216.016-.538-.172-.573-.422C17.474 7.398 14.711 5 11.5 5Zm.03 11.5a.5.5 0 0 1 0 1 .504.504 0 0 1-.505-.5c0-.245.173-.45.405-.492l.1-.008Zm2.45-.803a.5.5 0 0 1-.761.647c-.928-1.092-2.51-1.092-3.438 0a.5.5 0 0 1-.762-.647 3.23 3.23 0 0 1 4.961 0Zm-2.48-3.199c1.398 0 2.705.634 3.681 1.785a.5.5 0 1 1-.762.647c-.784-.923-1.82-1.432-2.919-1.432s-2.135.508-2.919 1.432a.5.5 0 0 1-.762-.647c.976-1.151 2.283-1.785 3.681-1.785Zm0-1.998c1.851 0 3.585.842 4.881 2.37a.5.5 0 1 1-.762.647C14.516 12.216 13.053 11.5 11.5 11.5s-3.016.716-4.119 2.017a.5.5 0 1 1-.762-.647c1.296-1.528 3.03-2.37 4.881-2.37Z",
    clipRule: "evenodd"
  })]
});